import React, { useState } from "react";
import { connect } from "react-redux";
import { change, getFormValues } from "redux-form";
import { FaHotel, FaRegMinusSquare, FaRegPlusSquare } from "react-icons/fa";
import TrapezeHeader from "Components/TrapezeHeader";
import { CompareButton } from "Components/Search/CompareButton";
import VenuesList from "./VenuesList";

const SelectedVenues = ({ active, form, change, selectedCompany }) => {
  const [expanded, setExpanded] = useState(true);
  const venues = active && active.venues ? active.venues : [];

  const removeVenue = index => {
    change(form, "venues", venues.filter((_, i) => i !== index));
  };

  return (
    <div className="mb-0 md:mb-5" style={{ maxHeight: 400, overflowY: "auto" }}>
      <div
        className="flex flex-wrap justify-between items-center bg-white pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <TrapezeHeader
          bgColor="orange"
          title="Selected Venues"
          icon={<FaHotel className="mr-2 text-white text-lg" />}
          bigText
          textLeft
        />
        {expanded ? (
          <FaRegMinusSquare className="pointer text-xl md:text-base mr-3" />
        ) : (
          <FaRegPlusSquare className="pointer text-xl md:text-base mr-3" />
        )}
      </div>
      {expanded && (
        <div className="bg-white p-3">
          {venues.length === 0 ? (
            <p className="text-sm text-center text-grey-md py-2">
              No venues selected — check venues from the results to add them here
            </p>
          ) : (
            <>
              <VenuesList items={venues} onRemove={removeVenue} />
              <div className="my-2">
                <CompareButton
                  venues={venues}
                  selectedCompany={selectedCompany}
                  buttonText={venues.length === 1 ? "Send Enquiry" : "Send Enquiries"}
                  route="/request-for-proposal"
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default connect(
  (state, props) => ({
    active: getFormValues(props.form)(state),
  }),
  { change }
)(SelectedVenues);
